import api from "./instance";

export default {
  fetchErrors: (token, page) =>
    api
      .get(`/error-log?page=${page}&perPage=10`, {
        headers: { Authorization: token }
      })
      .then(res => res)
};
